namespace $.$$ {
	export class $shm_dashboard_admin_book extends $.$shm_dashboard_admin_book {
		section( next?: string ) {
			if( next !== undefined ) this.$.$mol_state_arg.value( 'admin_section', next )
			const section = this.$.$mol_state_arg.value( 'admin_section' ) || 'users'
			return section === 'limits' ? 'wordstat' : section
		}

		users_current() { return this.section() === 'users' }
		wordstat_current() { return this.section() === 'wordstat' }

		admin_pages() {
			const page = this.section() === 'wordstat' ? this.Wordstat() : this.Users()
			return [ this.Menu(), page ]
		}
	}
}
